import { render, staticRenderFns } from "./DesempenhoNotaAluno.vue?vue&type=template&id=1749ff4c&scoped=true&"
import script from "./DesempenhoNotaAluno.vue?vue&type=script&lang=js&"
export * from "./DesempenhoNotaAluno.vue?vue&type=script&lang=js&"
import style0 from "./DesempenhoNotaAluno.vue?vue&type=style&index=0&id=1749ff4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1749ff4c",
  null
  
)

export default component.exports